import React from "react";

import { createRoot } from "react-dom/client";
import "@sippy-platform/valkyrie/valkyrie.css";

import Root from "./app/Root";
import store from "./store";
import "./style.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Root store={store} />
  </React.StrictMode>,
);
